import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getEmailConversation = async (params) => {
  const res = await axios.middleware(
    "https://middleware.cadernovirtual.com.br/Social.asmx/Mensagens",
    { params }
  );
  return res[0].data;
};

export const useEmailConversation = ({ config, studentId } = {}) => {
  const params = { alunoid: studentId };
  return useQuery({
    ...config,
    queryKey: ["emailConversation", { studentId }],
    queryFn: () => getEmailConversation(params),
  });
};
